<template>
    <div class="list">
        <slot></slot>
    </div>
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator';

    @Component
    export default class List extends Vue {
    }
</script>

<style lang="scss" scoped>
    div.list {
        background: var(--controls-background);
        border: 1px solid var(--list-border-color);
        font-size: 12pt;
    }
</style>
